import { useQuery } from '@tanstack/react-query';
import {CACHE_STALE_TIME_MINS} from "@/lib/constants.ts";
import reitService from "@/services/investments/reit/ReitService.ts";

/**
 * Custom hook to fetch REIT (Real Estate Investment Trust) sectors.
 * Utilizes the `useQuery` hook from React Query to make the data query.
 * The data is fetched using the `reitService.getSectors` function
 * and is cached for the specified stale time.
 *
 * @return {Object} An object containing the query state, including:
 * - `data`: The fetched REIT sectors data.
 * - `isLoading`: A boolean representing if the query is in a loading state.
 * - `error`: Any error returned during the query.
 * - Other properties provided by the `useQuery` hook for managing query state.
 */
export default function useFetchReitSectors() {
  return useQuery({
    queryKey: ['reit_sectors'],
    queryFn: async () => {
      return await reitService.getSectors();
    },
    staleTime: CACHE_STALE_TIME_MINS,
  });
}
